<template>
  <div>
    <notifications></notifications>
    <navmenu :menuMobile="true"></navmenu>
    <div class="container-fluid">
      <div class="row pt-lg-0 pt-md-0 pt-sm-0 pt-2 mob-log">
        <div
          data-aos="fade-in"
          class="col-xl-7 col-lg-7 col-md-7 col-sm-6 d-flex justify-content-center align-items-center min-vh-lg-100 flex-column img-back-pages align-self-center order-lg-1 order-md-1 order-sm-1 order-2"
        >
          <div class="overimg-back"></div>

          <div class="container">
            <div class="col-xl-12 container-footer-left">
              <div class="content-description-login">
                <span class="tagline-login">RhomTrip Mobility Suppliers</span>
                <h2 class="title-login">
                  Manage your operations, grow your business.
                </h2>

                <p class="descrip-login">
                  The all-in-one platform for ground transportation — built for
                  Suppliers.
                </p>

                <div class="features-login">
                  <div class="feature">
                    <i class="flaticon-calendar" aria-hidden="true"></i>
                    Real-time booking management
                  </div>
                  <div class="feature">
                    <i class="flaticon-wall-clock-1" aria-hidden="true"></i>
                    Availability & scheduling
                  </div>
                  <div class="feature">
                    <i class="flaticon-car-1" aria-hidden="true"></i> Fleet management
                  </div>
                  <div class="feature">
                    <i class="flaticon-driver" aria-hidden="true"></i>
                    Driver assignment
                  </div>
                </div>
              </div>

              <footer class="footer-pages-ext">
                <div class="bottom-footer-log">
                 <div class="partners-header login">
                    <a
                      href="https://www.iata.org"
                      target="_blank"
                      rel="noopener noreferrer"
                      ><div
                        class="partnership-iata-code animate__animated animate__zoomIn"
                      >
                        <img
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/rhomtrip-iata-code.png"
                          alt="iata-code travel"
                          class="img-fluid-partner alinmov1"
                        />
                      </div>
                    </a>

                    <a
                      href="https://www.asta.org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      ><div
                        class="partnership-asta animate__animated animate__zoomIn"
                      >
                        <img
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/asta-travel-advisors-w.png"
                          alt="asta"
                          class="img-fluid-partner alinmov1"
                        /></div></a
                    ><a
                      href="https://www.octo.travel/members"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="links-partnership animate__animated animate__zoomIn"
                      ><div class="partnership-octo">
                        <img
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/octo-travel.png"
                          alt="octo travel"
                          class="img-fluid-partner alinmov1"
                        />
                      </div>
                      <span>Founding Member</span></a
                    >

                    <a
                      href="https://www.tripadvisor.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      ><div
                        class="partnership-tripadvisor animate__animated animate__zoomIn"
                      >
                        <img
                          src="https://upcdn.io/FW25b8h/raw/signature/rhomtrip/tripadvisor-2023-2024.png"
                          alt="tripadvisor"
                          class="img-fluid-partner alinmov1"
                        /></div
                    ></a>
                  </div>
                </div>

                <div class="content pt-2">
                  <div class="content-footer align-self-center p-0">
                    <ul class="social-media">
                      <li>
                        <a
                          href="https://www.linkedin.com/company/rhomtrip"
                          target="blank"
                        >
                          <i class="flaticon-bold flaticon-bold-linkedin"></i>
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.instagram.com/rhomtrip/"
                          target="blank"
                        >
                          <i class="flaticon-bold flaticon-bold-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.facebook.com/Rhomtrip"
                          target="blank"
                        >
                          <i
                            class="flaticon-bold flaticon-bold-facebook-app-symbol"
                          ></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.x.com/rhomtrip"
                          target="_blank"
                          aria-label="contact RhomTrip"
                        >
                          <i class="flaticon-web-twitter-1"></i>
                        </a>
                      </li>

                      <li>
                        <a href="mailto:info@rhomtrip.com" target="_blank">
                          <i class="flaticon-envelope"></i>
                        </a>
                      </li>

                      <li>
                        <a href="https://rhomtrip.com/contact" target="blank">
                          <i class="flaticon-bold-telephone"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="content pt-2">
                  <div class="align-self-center">
                    <p class="copyright">
                      Copyright © {{ systemInfo.year }}. RhomTrip OÜ™. Register
                      Nº: 14554819. 
                    </p>
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div>

        <div
          class="col-xl-5 col-lg-5 col-md-5 col-sm-6 d-flex justify-content-center align-items-center min-vh-lg-100 align-self-center box-log order-lg-2 order-md-2 order-sm-2 order-1"
          data-aos="fade-in"
        >
          <div
            class="col-xl-8 col-lg-10 col-md-11 col-sm-12 col-12 pt-lg-0 pt-md-5 pt-sm-5 pt-0"
          >
            <div class="text-center mb-4 pages-all">
              <h1 class="title-view-2">Welcome back</h1>
              <div class="textInHorizontalLine">
                <span>Sign in</span>
              </div>
            </div>

            <div class="mb-0 mt-4">
            <form role="form" @submit.prevent>
              <div class="row">
                <div class="col-12 mb-3 mt-2">
                  <base-input
                    id="email"
                    name="email"
                    placeholder="Email"
                    v-model="data.email"
                    label="Email"
                    type="email"
                    markrequired
                    :error="
                      !$v.data.email.email || $v.data.email.$error
                        ? `Enter Email`
                        : ''
                    "
                    :focusact="true"
                  ></base-input>
                </div>

                <div class="col-12">
                  <base-input
                    v-model="$v.data.password.$model"
                    :label="$t('labelsForms.user.password')"
                    placeholder="Password"
                    name="password"
                    id="password"
                    :type="typePassword"
                    autocomplete="new-password"
                    maxlength="20"
                    class="input-append"
                    markrequired
                    :error="
                      !$v.data.password.minLength || $v.data.password.$error
                        ? `Enter a valid password`
                        : ''
                    "
                    v-bind:class="{
                      'is-invalid': $v.data.password.$error
                    }"
                    ><template slot="append">
                      <span @click="seePassword()" class="icon-button"
                        ><i
                          v-bind:class="{
                            'flaticon-view-1': typePassword == 'password',
                            'flaticon-hidden': typePassword == 'text'
                          }"
                        ></i
                      ></span>
                    </template>
                  </base-input>
                </div>

                <div class="col-12">
                  <base-checkbox
                    id="remember"
                    name="remember"
                    class="text-dark mb-3"
                    v-model="remember"
                    >Remember me</base-checkbox
                  >

                  <div class="text-center">
                    <base-button
                      type="primary"
                      class="min-button icon-move"
                      @click="login"
                      nativeType="submit"
                      >Sign in
                      <i class="ml-2 mr-0 flaticon-right-1 arrow-icon"></i
                    ></base-button>
                  </div>
                </div>
              </div>
            </form>

            <div class="mt-2 text-center mb-sm-0 mb-3">
              <router-link to="/forgot-password" class="d-block f-14"
                >Forgot your password?</router-link
              >
            </div>

            <div class="loading mt-5" v-if="load">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>

            <base-alert
              :type="alert.type"
              dismissible
              v-if="alert.status"
              class="alert-base"
            >
              <span class="alert-inner--icon">
                <i :class="alert.icon" class="mr-2"></i>
              </span>
              <span class="alert-inner--text">
                <strong>{{ alert.title }}</strong>
                {{ alert.message }}
              </span>
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </base-alert>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbarpages from "@/views/Layout/Navbarpages";
import endpoint from "../Commons/Services/index";
import { mapMutations, mapGetters } from "vuex";
import layoutFooter from "../Layout/ContentFooter";
import { required, minLength, email } from "vuelidate/lib/validators";
export default {
  components: {
    navmenu: Navbarpages,
    layoutFooter: layoutFooter
  },
  data() {
    return {
      data: {
        email: "",
        password: ""
      },
      message: "",
      remember: false,
      load: false,
      alert: {
        type: "",
        title: "",
        message: "",
        icon: "",
        class: "",
        status: false
      },
      typePassword: "password",
    };
  },
  created() {
    this.setSesion(null);
    this.setSigOut(false);
    localStorage.removeItem("es-login");
    localStorage.removeItem("settings");
    let remember = localStorage.checkbox && localStorage.checkbox;

    if (this.$route.query.email) {
      this.data.email = this.$route.query.email;
    } else {
      this.data.email = remember ? localStorage.user_email : "";
      this.data.password = remember ? localStorage.pass : "";
    }
    this.setTempPagination({
      currentPage: 1,
      query: "",
      queryTemp: "",
      filteredTabStatus: "all",
      limit: "15",
      status: false
    });
  },
  methods: {
    async login() {
      try {
        if (!this.$v.$invalid) {
          this.rememberMe();
          this.load = true;
          let { data } = await endpoint.auth.services.login({
            email: this.data.email.toLowerCase(),
            password: this.data.password
          });
          this.load = false;
          if (data.status) {
            let sesion = data.data;
            if (sesion.role === "supplier") {
              sesion["status"] = true;
              localStorage.setItem("es-login", JSON.stringify(sesion));
              this.setSettings(sesion.settings);
              this.setSesion(sesion);
              this.$router.push("/reservations");
            } else {
              this.loginError();
            }
          } else {
            this.loginError();
          }
        } else {
          this.$v.data.$touch();
        }
      } catch (error) {
        this.load = false;
        if (error.response.status === 404) {
          let data = error.response.data.data;
          if (data.profile === "inactive") {
            this.loginWarning();
          } else {
            this.loginError();
          }
        } else {
          this.loginError();
        }
      }
    },
    loginError() {
      this.alert = {
        type: "danger",
        title: "Error!",
        message: "Incorrect Email or Password Entered",
        icon: "flaticon-remove",
        class: "alert-danger",
        status: true
      };
    },
    loginWarning() {
      this.alert = {
        type: "warning",
        title: "Important!",
        message: "This user is currently inactive",
        icon: "flaticon-warning-1",
        class: "alert-warning",
        status: true
      };
    },
    rememberMe() {
      if (this.remember && this.data.email !== "") {
        localStorage.user_email = this.data.email;
        localStorage.pass = this.data.password;
        localStorage.checkbox = this.remember;
      } else {
        localStorage.user_email = "";
        localStorage.checkbox = "";
        localStorage.pass = "";
      }
    },
    seePassword() {
      this.typePassword = this.typePassword == "password" ? "text" : "password";
    },
    ...mapMutations([
      "setSesion",
      "setSigOut",
      "setLoad",
      "setSettings",
      "setTempPagination",
      "setSystemInfo",
      "setModuleSettings"
    ])
  },
  computed: {
    ...mapGetters(["systemInfo"])
  },
  validations: {
    data: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      }
    }
  }
};
</script>
